import styled from "styled-components";

import { setFontVariant } from "@similarweb/styles";
import { RadioButton, RadioLabelText } from "@similarweb/ui-components";

export const StyledInfoIcon = styled.div`
    margin-left: 8px;
`;

export const StyledRadioButton = styled(RadioButton)`
    padding: 0;

    ${RadioLabelText} {
        ${({ buttonSize }) => setFontVariant(buttonSize === "sm" ? "report" : "body1")};
    }
`;

export const StyledRadioContainer = styled.div`
    align-items: center;
    display: flex;

    &:not(:last-child) {
        margin-right: 32px;
    }
`;
